import React from 'react';

export interface CSVButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  disabled?: boolean;
}

export const CSVButton: React.FC<CSVButtonProps> = ({
  onClick,
  label = 'CSV',
  className = '',
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`bg-[#F9C327] hover:bg-[#E5B21E] text-white text-sm px-4 py-1.5 rounded-xl flex items-center gap-2 cursor-pointer transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      title="Download CSV"
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
      </svg>
      <span>{label}</span>
    </button>
  );
};

export default CSVButton;
